import * as yup from 'yup';

import { ICompanySettings } from 'auth/types';
import { upsertCustomerQuoteSchema } from 'quotes/components/CustomerQuoteUpsert';
import { ItemsToCopyField } from 'quotes/components/QuotePartAddToQuote';
import { QuoteEntityType } from 'quotes/enums';

const defaultCompanySettings: ICompanySettings = {
  coreOrderIntegrationEnabled: false,
  ddpOrderIntegrationEnabled: false,
  verticalMarketRequired: 0,
};

const itemsToCopySchemas = Object.values(ItemsToCopyField).reduce((acc, value) => {
  acc[value] = yup.boolean().nullable();

  return acc;
}, {});

export const duplicateQuoteSchema = (
  entityType = QuoteEntityType.QUOTE,
  companySettings = defaultCompanySettings,
  isAlternateVersionEnabled = false
) => {
  const baseSchema = upsertCustomerQuoteSchema({
    entityType,
    companySettings,
    isAlternateVersionEnabled,
  });

  return yup.object().shape({
    ...baseSchema.fields,
    ...itemsToCopySchemas,
  });
};
